import React, {Component} from 'react';
import CommonUtils from '../utils/CommonUtils';
import BrandUtils from '../utils/BrandUtils';
import Constants from '../utils/Constants';
import '../styles/TipPlaceholder.css';

class TipPlaceholder extends Component {
  render() {
    let {firstTip, secondTip} = this.props;
    if(CommonUtils.isEmpty(firstTip)) {
      firstTip = BrandUtils.getCachedBrandName()
    }
    if(CommonUtils.isEmpty(firstTip)) {
      firstTip = Constants.Strings.APP_NAME
    }

    return (
      <div className="tip-placeholder">
        <div className="content">{firstTip}</div>
        <div className="content">{secondTip}</div>
      </div>
    );
  }
}

export default TipPlaceholder;


// WEBPACK FOOTER //
// ./src/components/TipPlaceholder.js